export const testimonials = [
  {
    id: 1,
    nameEn: 'Ahmed Al Balushi',
    nameAr: 'أحمد البلوشي',
    location: 'Muscat',
    serviceUsed: 'Deep Cleaning',
    rating: 5,
    language: 'ar',
    reviewEn: '',
    reviewAr: 'خدمة ممتازة من كل النواحي! الفريق وصل في الوقت المحدد وعمل بجد واحترافية عالية. فيلتي أصبحت نظيفة تماماً حتى في الأماكن التي يصعب الوصول إليها. سي بيرل يونيفرسال هي الأفضل في مسقط، أنصح بها بشدة لكل من يريد تنظيفاً احترافياً حقيقياً.',
    avatar: 'https://public.readdy.ai/ai/img_res/69d54e3601c06a742fc3298703dee838.jpg'
  },
  {
    id: 2,
    nameEn: 'Rajesh Kumar',
    nameAr: '',
    location: 'Al Khuwair',
    serviceUsed: 'Office Cleaning',
    rating: 5,
    language: 'en',
    reviewEn: 'We hired Sea Pearl Universal for our office deep clean and the results were outstanding. The team was punctual, professional, and incredibly thorough. Every corner was spotless. We now have a monthly contract with them — best decision we made for our workplace!',
    reviewAr: '',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20friendly%20Indian%20businessman%20in%20his%2040s%20smiling%20confidently%2C%20clean%20white%20background%2C%20formal%20shirt%2C%20warm%20expression%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=avatar-002&orientation=squarish'
  },
  {
    id: 3,
    nameEn: 'Fatima Al Lawati',
    nameAr: 'فاطمة اللواتية',
    location: 'Seeb',
    serviceUsed: 'Sofa Cleaning',
    rating: 5,
    language: 'ar',
    reviewEn: '',
    reviewAr: 'كنت قلقة على كنبتي الفاخرة لكن الفريق تعامل معها بعناية فائقة. البقع القديمة اختفت تماماً والكنب يبدو كأنه جديد من المحل. الأسعار معقولة جداً مقارنة بالجودة المقدمة. شكراً سي بيرل يونيفرسال!',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20friendly%20Omani%20Arab%20woman%20smiling%2C%20clean%20white%20background%2C%20modest%20professional%20attire%2C%20warm%20expression%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=avatar-003&orientation=squarish'
  },
  {
    id: 4,
    nameEn: 'James O\'Brien',
    nameAr: '',
    location: 'Azaiba',
    serviceUsed: 'Post Construction Cleaning',
    rating: 5,
    language: 'en',
    reviewEn: 'Just moved into our newly built villa and the post-construction mess was overwhelming. Sea Pearl Universal cleared everything — cement dust, paint splashes, debris — in a single day. The house was move-in ready immediately. Absolutely brilliant service, highly recommend!',
    reviewAr: '',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20friendly%20Western%20expat%20man%20in%20his%2040s%20smiling%2C%20clean%20white%20background%2C%20casual%20smart%20attire%2C%20warm%20expression%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=avatar-004&orientation=squarish'
  },
  {
    id: 5,
    nameEn: 'Khalid Al Amri',
    nameAr: 'خالد العامري',
    location: 'Mabela',
    serviceUsed: 'Carpet Cleaning',
    rating: 5,
    language: 'ar',
    reviewEn: '',
    reviewAr: 'سجادي الفارسي كان به بقع منذ سنوات وكنت أظن أنه لا يمكن إنقاذه. بعد خدمة سي بيرل يونيفرسال أصبح كالجديد تماماً! المعدات المستخدمة احترافية والمنتجات آمنة للأطفال. سأتعامل معهم دائماً.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20Omani%20Arab%20man%20in%20his%2040s%20smiling%2C%20clean%20white%20background%2C%20traditional%20dishdasha%20attire%2C%20warm%20expression%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=avatar-005&orientation=squarish'
  },
  {
    id: 6,
    nameEn: 'Priya Nair',
    nameAr: '',
    location: 'Mawaleh',
    serviceUsed: 'Part-Time Maid',
    rating: 5,
    language: 'en',
    reviewEn: 'The part-time maid service has been a total lifesaver for our family. Our maid is reliable, hardworking, and treats our home with real care. She handles everything perfectly — from vacuuming to laundry. I recommend Sea Pearl Universal to every busy family in Muscat!',
    reviewAr: '',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20happy%20Indian%20woman%20in%20her%20late%2020s%20smiling%20warmly%2C%20clean%20white%20background%2C%20smart%20casual%20attire%2C%20friendly%20expression%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=avatar-006&orientation=squarish'
  }
];
